module.exports = __webpack_public_path__ + "static/tusas-8-0a74d88c149ec0cc059942501a9c478e.png";